export default __webpack_public_path__ + "static/media/siqueiratur.a3dcf89b.png";